<header class="header" appClickOutside (clickOutside)="closeAllMenus()" menuClass="js-header-menu">
  <div class="header__content">
    <!-- TODO: apps launcher - the redesign shows the 3x3 dot grid but no target
         is defined for it yet, so the button is intentionally inert. -->
    @if (showAppsLauncher()) {
      <button type="button" class="apps-launcher" (click)="onAppsLauncherClick()">
        @for (dot of appsLauncherDots; track $index) {
          <span class="apps-launcher__dot"></span>
        }
      </button>
    }

    <!-- TODO: logo-white-1 (hr.ge) and logo-white-21 (hr.am) are still recoloured
         copies of logo-*.svg - replace them with the official dark-header logos
         once design delivers them (cv, doctor and chefs already come from Figma). -->
    @if (!isActive('/')) {
      <a class="logo" [routerLink]="['/']" menuNavItem>
        <img class="logo__img" [src]="'assets/img/common/logo-white-' + providerWebsiteId + '.svg'" alt="" />
      </a>
    } @else {
      <a class="logo" [routerLink]="['/']" [queryParams]="{ r: 1 }" menuNavItem>
        <img class="logo__img" [src]="'assets/img/common/logo-white-' + providerWebsiteId + '.svg'" alt="" />
      </a>
    }

    <div class="auth-actions">
      <a class="button button--outlined" [routerLink]="['/jobseeker/register']" menuNavItem>
        {{ 'label.CvRegistration' | translate }}
      </a>
      <a class="button button--outlined" [routerLink]="['/jobseeker/sign-in']" menuNavItem>
        {{ 'label.SignIn' | translate }}
      </a>
    </div>

    <nav class="nav">
      <a class="nav__link favourite-box" [routerLink]="['/announcement/favorites']" menuNavItem>
        <svg-icon class="nav__icon nav__icon--heart" [src]="favoritesIcon()"></svg-icon>
        <span class="nav__text">{{ 'label.Favorites' | translate }}</span>
        @if (((favCount$ | async) ?? 0) > 0) {
          <span class="nav__count">{{ favCount$ | async }}</span>
        }
      </a>
      <a class="nav__link" [routerLink]="['/cvbox']" menuNavItem>
        <svg-icon class="nav__icon nav__icon--box" [svgClass]="'ico-cv-box'" src="assets/icons/cv-box-company.svg"></svg-icon>
        <span class="nav__text">{{ 'label.CvBoxes' | translate }}</span>
      </a>
      <a class="nav__link" [routerLink]="['/subscriber/subscription']" menuNavItem>
        <svg-icon class="nav__icon nav__icon--mail" src="assets/icons/header-2-mail.svg"></svg-icon>
        <span class="nav__text">{{ 'label.Subscribe' | translate }}</span>
      </a>
      @if (blogEnabled$ | async) {
        <a class="nav__link" [href]="blogUrl$ | async" target="_blank" rel="noopener noreferrer" menuNavItem>
          <span class="nav__text">{{ 'label.Blog' | translate }}</span>
        </a>
      }
    </nav>

    <span class="header__spacer"></span>

    <div class="header__actions">
      <div class="employers">
        <button type="button" class="button button--filled employers__toggle" (click)="toggleEmployersMenu()">
          <span class="employers__toggle-text">{{ 'label.ForEmployers' | translate }}</span>
          <svg-icon class="caret" src="assets/icons/header-2-caret-down.svg"></svg-icon>
        </button>

        @if (isEmployersMenuOpen) {
          <!-- TODO: the desktop open state of this dropdown is not in the Figma
               file - the items below are taken from the burger menu design and
               all of them still need their targets. -->
          <div class="dropdown employers__menu">
            <div class="employers__menu-actions">

              <a class="button button--accent" href="{{ (customerPortalUrl$ | async) }}/customer/register" target="_blank" menuNavItem>
                {{ 'label.CompanyRegistration' | translate }}
              </a>

              <a class="button button--filled button--bordered" href="{{ (customerPortalUrl$ | async) }}/sign-in" target="_blank" menuNavItem>
                {{ 'label.CompanyLogin' | translate }}
              </a>
            </div>
            <div class="employers__menu-links">
              <a class="employers__menu-link" [routerLink]="['/info', 'services-hr-ge']" menuNavItem>{{ 'label.ProductsAndPrices' | translate }}</a>
              <a class="employers__menu-link" [routerLink]="['/info', 'frequently-asked-questions-hr-ge']" menuNavItem>{{ 'label.FaqShort' | translate }}</a>
              <a class="employers__menu-link" [routerLink]="['/info', 'contact-us-hr-ge']" menuNavItem>{{ 'label.Contact' | translate }}</a>
            </div>
          </div>
        }
      </div>

      <!-- TODO: theme switching is not implemented yet, the button only matches the design;
           hidden behind the enableDarkMode static feature flag until it works -->
      @if (isDarkModeEnabled) {
        <button type="button" class="theme-toggle" (click)="toggleTheme()">
          <span class="theme-toggle__glyph">&#9790;</span>
        </button>
      }

      @if (languages?.length) {
        <div class="language">
          <button type="button" class="language__toggle" (click)="toggleLanguageMenu()">
            <!-- TODO: the design uses three letter codes (GEO / ENG / RUS), the
                 existing label.lang-short-* translations return two letters. -->
            <span class="language__toggle-text">{{ ('label.lang-short-' + currentLanguage) | translate }}</span>
            <svg-icon class="caret" src="assets/icons/header-2-caret-down.svg"></svg-icon>
          </button>

          @if (isLanguageMenuOpen) {
            <div class="dropdown language__menu">
              @for (language of languages; track language) {
                <button
                  type="button"
                  class="language__menu-item"
                  [class.language__menu-item--active]="language === currentLanguage"
                  (click)="selectLanguage(language)"
                >
                  {{ ('label.lang-short-' + language) | translate }}
                </button>
              }
            </div>
          }
        </div>
      }
    </div>

    <button type="button" class="menu-toggle" (click)="toggleBurgerMenu()">
      <svg-icon class="menu-toggle__icon" src="assets/icons/header-2-menu.svg"></svg-icon>
    </button>
  </div>

  @if (isBurgerMenuOpen) {
    <div class="burger-menu">
      <div class="burger-menu__content">
        <div class="burger-menu__auth">
          <a class="button button--outlined button--block" [routerLink]="['/jobseeker/register']" menuNavItem>
            {{ 'label.CvRegistration' | translate }}
          </a>
          <a class="button button--outlined button--block" [routerLink]="['/jobseeker/sign-in']" menuNavItem>
            {{ 'label.SignIn' | translate }}
          </a>
        </div>

        <a class="burger-menu__row favourite-box-responsive" [routerLink]="['/announcement/favorites']" menuNavItem>
          <svg-icon class="burger-menu__icon burger-menu__icon--heart" [src]="favoritesIcon()"></svg-icon>
          <span class="burger-menu__text">{{ 'label.Favorites' | translate }}</span>
          @if (((favCount$ | async) ?? 0) > 0) {
            <span class="burger-menu__count">{{ favCount$ | async }}</span>
          }
        </a>
        <a class="burger-menu__row" [routerLink]="['/cvbox']" menuNavItem>
          <svg-icon class="burger-menu__icon burger-menu__icon--box" src="assets/icons/header-2-cv-box.svg"></svg-icon>
          <span class="burger-menu__text">{{ 'label.CvBoxes' | translate }}</span>
        </a>
        <a class="burger-menu__row" [routerLink]="['/subscriber/subscription']" menuNavItem>
          <svg-icon class="burger-menu__icon burger-menu__icon--mail" src="assets/icons/header-2-mail.svg"></svg-icon>
          <span class="burger-menu__text">{{ 'label.Subscribe' | translate }}</span>
        </a>
        @if (blogEnabled$ | async) {
          <a class="burger-menu__row" [href]="blogUrl$ | async" target="_blank" rel="noopener noreferrer" menuNavItem>
            <span class="burger-menu__text">{{ 'label.Blog' | translate }}</span>
          </a>
        }

        @if (languages?.length) {
          <div class="burger-menu__row burger-menu__row--languages">
            <!-- TODO: the design shows a third language (RUS) which the store does not expose yet -->
            @for (language of languages; track language) {
              <button
                type="button"
                class="burger-menu__language"
                [class.burger-menu__language--active]="language === currentLanguage"
                (click)="selectLanguage(language)"
              >
                {{ ('label.lang-short-' + language) | translate }}
              </button>
            }
          </div>
        }

        <!-- TODO: theme switching is not implemented yet, the row only matches the design;
             hidden behind the enableDarkMode static feature flag until it works -->
        @if (isDarkModeEnabled) {
          <button type="button" class="burger-menu__row burger-menu__row--theme" (click)="toggleTheme()">
            <span class="burger-menu__theme-glyph">&#9790;</span>
            <span class="burger-menu__text">{{ 'label.DarkMode' | translate }}</span>
          </button>
        }

        <div class="burger-menu__employers">
          <a class="button button--filled button--block" href="{{ (customerPortalUrl$ | async) }}/dashboard" target="_blank" menuNavItem>
            {{ 'label.ForEmployers' | translate }}
          </a>

          <div class="burger-menu__employers-actions">

            <a class="button button--accent button--block" href="{{ (customerPortalUrl$ | async) }}/customer/register" target="_blank" menuNavItem>
              {{ 'label.CompanyRegistration' | translate }}
            </a>
            <!-- TODO: point to the customer portal sign in page -->
            <a class="button button--filled button--bordered button--block" menuNavItem>
              {{ 'label.CompanyLogin' | translate }}
            </a>
          </div>

          <div class="burger-menu__employers-links">
            <a class="burger-menu__employers-link" [routerLink]="['/info', 'services-hr-ge']" menuNavItem>{{ 'label.ProductsAndPrices' | translate }}</a>
            <a class="burger-menu__employers-link" [routerLink]="['/info', 'frequently-asked-questions-hr-ge']" menuNavItem>{{ 'label.FaqShort' | translate }}</a>
            <a class="burger-menu__employers-link" [routerLink]="['/info', 'contact-us-hr-ge']" menuNavItem>{{ 'label.Contact' | translate }}</a>
          </div>
        </div>
      </div>
    </div>
  }
</header>
